import { axiosPost, axiosPut } from 'shared/api/axios'
import { AxiosError } from 'axios'
import { apiUrls } from 'consts'
import displayGenError from 'shared/utils/displayGenError'
import setFormValidationError from 'shared/utils/setFormValidationError'

interface submitFormProps {
  data: any
  setShowOverlay: Function
  id: string | undefined
  setError: Function
  isDeviceReplacement: boolean
}

const toCamelCase = (s: string): string => {
  return s.replace(/([-_][a-z])/gi, ($1) => {
    return $1.toUpperCase().replace('-', '').replace('_', '')
  })
}

const submitForm = async (props: submitFormProps) => {
  let response: any = false

  //do not sent read-only props to the server
  delete props.data['last_used_by']
  delete props.data['last_used_date']
  delete props.data['customer']

  //map objects to model attributes from react-selects
  ;[
    'type',
    'manufacturer',
    'model',
    'carrier',
    'site',
    'center',
    'service_status',
    'failure',
  ].forEach((attribute) => {
    const modelAttrName = toCamelCase(attribute)
    props.data[attribute + '_id'] = props.data[modelAttrName]?.id ?? null
  })

  const formData = {
    ...props.data,
    is_final_replacement_request: props.isDeviceReplacement,
  }

  let mappedAttributes: Map<string, string> = new Map()
  mappedAttributes.set('mac_address', 'mac_address')
  mappedAttributes.set('serial_number', 'serial_number')
  mappedAttributes.set('label', 'label')
  mappedAttributes.set('type_id', 'type')
  mappedAttributes.set('manufacturer_id', 'manufacturer')
  mappedAttributes.set('model_id', 'model')
  mappedAttributes.set('center_id', 'center')
  mappedAttributes.set('origin_rma', 'origin_rma')
  mappedAttributes.set('owner', 'owner')
  mappedAttributes.set('production_date', 'production_date')
  mappedAttributes.set('warranty_expiration_date', 'warranty_expiration_date')
  mappedAttributes.set('service_status_id', 'serviceStatus')
  mappedAttributes.set('rma', 'rma')
  mappedAttributes.set('failure_id', 'failure')

  const catchFn = (err: AxiosError) => {
    if (err.response!.status === 422) {
      setFormValidationError(err, props.setError, mappedAttributes, 'label')
    } else {
      displayGenError({ setShowOverlay: props.setShowOverlay })
    }
  }

  if (props.id === undefined) {
    response = await axiosPost(apiUrls.devices, formData, catchFn)
  } else {
    response = await axiosPut(apiUrls.devices + '/' + props.id, formData, catchFn)
  }

  return response
}

export default submitForm
